module.exports = __webpack_public_path__ + "assets/img/3-pistes-solutions-gestion-doc-rh.55c859a2.jpg";